import { apps, AppData } from '../data/appData';

export type Store = 'appstore' | 'googleplay';
export type Platform = 'ios' | 'android' | 'desktop';

export const getApp = (id: string): AppData => {
    const app = apps.find((a) => a.id === id);
    if (!app) throw new Error(`Unknown app: ${id}`);
    return app;
};

export const shiftwave = getApp('shiftwave');
export const copapp = getApp('copapp');

// The smart link detects the device and sends it to the right store, so it's
// what the desktop QR codes point at.
export const smartLink = (appId: string) => `https://www.myprojectx.com/app/${appId}?redirect=true`;

export const qrCodeUrl = (appId: string, size = 180) =>
    `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&margin=8&data=${encodeURIComponent(smartLink(appId))}`;

export const detectPlatform = (): Platform => {
    const ua = navigator.userAgent || '';
    // iPadOS reports itself as a Mac, so also check for touch support.
    const isIPad = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
    if (/iPad|iPhone|iPod/.test(ua) || isIPad) return 'ios';
    if (/android/i.test(ua)) return 'android';
    return 'desktop';
};

// Reports a store-button click to Google Analytics (gtag is loaded in index.html).
export const trackDownload = (appId: string, store: Store, placement: string) => {
    const gtag = (window as any).gtag;
    if (typeof gtag === 'function') {
        gtag('event', 'download_click', { app_id: appId, store, placement });
    }
};
